// @flow
import { createMeta } from "../../../components/TapHeader";

const title = "Team Directory";
export const OrgSettingsMeta = createMeta(title);
